/**
 * Sticky Add to Cart
 * Shows a floating add-to-cart button when the user scrolls past the main product section.
 */
(function () {
  var stickyEl = document.querySelector('.sticky-atc');
  if (!stickyEl) return;

  var sectionId = stickyEl.dataset.sectionId;
  var productSection = document.getElementById('MainProduct-' + sectionId);
  if (!productSection) return;

  var formId = stickyEl.dataset.formId;
  var stickyBtn = stickyEl.querySelector('.sticky-atc__btn');
  var isVisible = false;

  /* ---- Scroll observer: show when product section leaves viewport ---- */
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var shouldShow = !entry.isIntersecting;
        if (shouldShow !== isVisible) {
          isVisible = shouldShow;
          stickyEl.classList.toggle('is-visible', isVisible);
        }
      });
    },
    { threshold: 0, rootMargin: '0px 0px 0px 0px' }
  );

  observer.observe(productSection);

  /* ---- Click handler: submit the main product form with animation ---- */
  if (stickyBtn && formId) {
    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.classList.contains('is-adding') || stickyBtn.classList.contains('is-added')) return;

      var form = document.getElementById(formId);
      if (!form) return;

      var variantInput = form.querySelector('input[name="id"]');
      if (variantInput && variantInput.disabled) return;

      /* Phase 1: press down */
      stickyBtn.classList.add('is-adding');

      /* Phase 2: trigger the actual form submit */
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.click();
      }

      /* Phase 3: show checkmark after a short delay */
      setTimeout(function () {
        stickyBtn.classList.remove('is-adding');
        stickyBtn.classList.add('is-added');

        /* Phase 4: revert back to normal */
        setTimeout(function () {
          stickyBtn.classList.remove('is-added');
        }, 1800);
      }, 300);
    });
  }

  /* ---- Keep price + availability in sync with variant changes ---- */
  var priceEl = stickyEl.querySelector('.sticky-atc__price');
  var priceContainer = document.getElementById('price-' + sectionId);

  if (priceContainer) {
    var mutationObserver = new MutationObserver(function () {
      /* Update price from the main PDP price block */
      var mainPrice = priceContainer.querySelector('.price-item--regular');
      var salePrice = priceContainer.querySelector('.price-item--sale');
      if (priceEl) {
        var displayPrice = salePrice && salePrice.textContent.trim()
          ? salePrice.textContent.trim()
          : mainPrice
            ? mainPrice.textContent.trim()
            : '';
        if (priceEl.textContent !== displayPrice) {
          priceEl.textContent = displayPrice;
        }
      }

      /* Update disabled state */
      var mainSubmit = document.getElementById('ProductSubmitButton-' + sectionId);
      if (mainSubmit && stickyBtn) {
        var shouldDisable = mainSubmit.disabled;
        if (stickyBtn.disabled !== shouldDisable) {
          stickyBtn.disabled = shouldDisable;
        }
      }
    });

    /* Only observe the price block — NOT the whole product-info tree
       which contains the sticky-atc (that would create an infinite loop). */
    mutationObserver.observe(priceContainer, { childList: true, subtree: true, characterData: true });
  }

  /* Also watch the submit button for disabled-state changes */
  var mainSubmitBtn = document.getElementById('ProductSubmitButton-' + sectionId);
  if (mainSubmitBtn) {
    var attrObserver = new MutationObserver(function () {
      if (stickyBtn) {
        var shouldDisable = mainSubmitBtn.disabled;
        if (stickyBtn.disabled !== shouldDisable) {
          stickyBtn.disabled = shouldDisable;
        }
      }
    });
    attrObserver.observe(mainSubmitBtn, { attributes: true, attributeFilter: ['disabled'] });
  }
})();
